import type { ConversationNodeBusinessHours } from 'lib-shared-types-api';
import moment from 'moment-timezone';
import type { ReactNode } from 'react';

type Props = {
  node: ConversationNodeBusinessHours;
};

function getScheduleText(node: ConversationNodeBusinessHours): ReactNode {
  if (!node.intervals) {
    return null;
  }

  if (node.is_open) {
    return `from ${node.intervals.start} - ${node.intervals.end}`;
  }

  const format = 'HH:mm';

  const timestamp = moment.utc(node.timestamp).format(format);
  const actionTime = moment.utc(timestamp, format);
  const startTime = moment.utc(node.intervals.start, format);

  if (actionTime.isBefore(startTime)) {
    return `before ${node.intervals.start}`;
  }

  return `after ${node.intervals.end}`;
}

export function RoutedThroughBusinessHours({ node }: Props): JSX.Element {
  return (
    <>
      Business hours · <strong>{node.is_open ? 'Open' : 'Closed'}</strong> on{' '}
      {node.name} {getScheduleText(node)}
    </>
  );
}
